module.exports = __webpack_public_path__ + "static/media/transform-experience-with-ai.20b60d6d.png";